import { toast } from 'react-toastify';

const successToast = (message) => toast.success(message);

const errorToast = (messsage) => toast.error(messsage);

const infoToast = (message) => toast.info(message);

export { successToast, errorToast, infoToast }
